module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst durations = []\nif(attributes.customerStartTS && attributes.customerEndTS)                  durations.push(utils.number.format(attributes.customerDuration || 0, '', 'float').formatted);\nelse                                                                        durations.push('-');\nif(attributes.startTS && attributes.endTS)                                  durations.push(utils.number.format(attributes.duration || 0, '', 'float').formatted);\nelse                                                                        durations.push('-');\nif(attributes.shippingOrderStartTS && attributes.shippingOrderEndTS)        durations.push(utils.number.format(attributes.shippingOrderDuration || 0, '', 'float').formatted);\nelse                                                                        durations.push('-');\nif(attributes.timeRegistrationStartTS && attributes.timeRegistrationEndTS)  durations.push(utils.number.format(attributes.timeRegistrationDuration || 0, '', 'float').formatted);\nelse                                                                        durations.push('-');\n%><div>\n<%= durations.join(' / ') %>\n</div>"
  , __filename = "components/templates/office/projectTermJobs/tableFields/durations.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const durations = []
if(attributes.customerStartTS && attributes.customerEndTS)                  durations.push(utils.number.format(attributes.customerDuration || 0, '', 'float').formatted);
else                                                                        durations.push('-');
if(attributes.startTS && attributes.endTS)                                  durations.push(utils.number.format(attributes.duration || 0, '', 'float').formatted);
else                                                                        durations.push('-');
if(attributes.shippingOrderStartTS && attributes.shippingOrderEndTS)        durations.push(utils.number.format(attributes.shippingOrderDuration || 0, '', 'float').formatted);
else                                                                        durations.push('-');
if(attributes.timeRegistrationStartTS && attributes.timeRegistrationEndTS)  durations.push(utils.number.format(attributes.timeRegistrationDuration || 0, '', 'float').formatted);
else                                                                        durations.push('-');

    ; __line = 13
    ; __append("<div>\n")
    ; __line = 14
    ; __append(escapeFn( durations.join(' / ') ))
    ; __append("\n</div>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/projectTermJobs/tableFields/durations.ejs

}